"use strict";

module.exports = {
  'name': 'version',
  'category': 'Constants',
  'syntax': ['version'],
  'description': 'A string with the version number of math.js',
  'examples': ['version'],
  'seealso': []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/constants/version.js
// module id = 799
// module chunks = 0